module.exports = __webpack_public_path__ + "static/img/preview-01.7b924c63.webp";